import { BaseLayout, type NavSection } from './BaseLayout';
import {
  Home, Users, CalendarDays, Mail, Bell, FileText, Settings, Calendar,
  BarChart3, Eye, School,
} from 'lucide-react';
import { useProfileBrandColor } from '../../theme/useProfileBrandColor';

const NAV_SECTIONS: NavSection[] = [
  {
    title: null,
    items: [
      { to: '/responsavel/dashboard', label: 'Início', icon: Home },
    ],
  },
  {
    title: 'Dia a Dia',
    items: [
      { to: '/responsavel/filhos', label: 'Meus Filhos', icon: Users },
      { to: '/responsavel/agenda', label: 'Agenda Escolar', icon: Calendar },
      { to: '/responsavel/frequencia', label: 'Frequência', icon: CalendarDays },
    ],
  },
  {
    title: 'Comunicação',
    items: [
      { to: '/responsavel/comunicados', label: 'Comunicados', icon: Mail },
      { to: '/responsavel/notificacoes', label: 'Notificações', icon: Bell },
      { to: '/responsavel/justificativas', label: 'Justificativas', icon: FileText },
    ],
  },
  {
    title: 'Vida Escolar',
    items: [
      { to: '/responsavel/desempenho', label: 'Boletim & Notas', icon: BarChart3 },
      { to: '/responsavel/observacoes', label: 'Observações', icon: Eye },
      { to: '/responsavel/escola', label: 'Minha Escola', icon: School },
    ],
  },
  {
    title: 'Configurações',
    items: [
      { to: '/responsavel/perfil', label: 'Meu Perfil', icon: Settings },
    ],
  },
];

export function ResponsavelLayout() {
  const { brandColor, brandGradient } = useProfileBrandColor('RESPONSAVEL');
  return (
    <BaseLayout
      sections={NAV_SECTIONS}
      headerTitle="Painel do Responsável"
      brandColor={brandColor}
      brandGradient={brandGradient}
    />
  );
}
